import { Box } from "@mui/material";
import MuiIconButton from "@mui/material/IconButton";

const IconButton = ({ sx = {}, icon, name, onClick, ...others }) => {
  const defaultStyles = {
    height: "30px",
    width: "30px",
  };

  const combinedStyles = { ...defaultStyles, ...sx };

  return (
    <MuiIconButton onClick={onClick} {...others}>
      <Box component="img" src={icon} sx={combinedStyles} {...others} />
      {name}
    </MuiIconButton>
  );
};

export default IconButton;
